module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./index.js"));
	}, "DietitianRegister");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DietitianRegister!./src/pages/Promote/DietitianRegister/Guide/index.js
// module id = 1189
// module chunks = 431